import { Currencies, Global, FullManagement, ClearPricing, LowerCosts, NopaperImg, InsatntSetupImg, FeeImg } from "../components/images/svg/icons";
import { Header_Laptop , Header_Phone} from "../components/images//png/icons";

export const features = [
    {
        icon: NopaperImg,
        title: 'NO_PAPER_WORK',
        description: 'NO_PAPER_WORK_DESCRIPTION',
    },
    {
        icon: InsatntSetupImg,
        title: 'INSTANT_SETUP',
        description: 'INSTANT_SETUP_DESCRIPTION',
    },
    {
        icon: FeeImg,
        title: 'FEE',
        description: 'FEE_DESCRIPTION',
    },
];
export const bussinessfeatures = [
    {
        icon: ClearPricing,
        title: 'CLEAR_PRICING',
        description: 'CLEAR_PRICING_DESCRIPTION'
    },
    {
        icon: FullManagement,
        title: "FULL_MANAGEMENT",
        description: "FUll_MANAGEMENT_DESCRIPTION",
    },
    {
        icon: LowerCosts,
        title: "LOWER_COSTS",
        description: "LOWER_COSTS_DESCRIPTION"
    },
];
export const heroCards = [
    {
        type: "currencies",
        content: {
            number: 11,
            label: "CURRENCIES",
            img: Currencies,
            imgClass: "hero-card-img",
        },
    },
    {
        type: "laptop",
        img: Header_Laptop,
        alt: "Laptop",
    },
    {
        type: "phone",
        img: Header_Phone,
        alt: "Phone",
    },
    {
        type: "insurance",
        content: {
            img: Global,
            imgClass: "hero-card-insurance-img",
            label: "INSURANCE",
            labelClass: "hercard-insuranceo-",
        },
    },
];